import type { Language } from '../types';

export const SITE_ORIGIN = 'https://www.sparkr.tech';

export const stripLocalePrefix = (pathname: string): string => {
  if (pathname.startsWith('/en/')) return pathname.slice(3);
  if (pathname.startsWith('/es/')) return pathname.slice(3);
  if (pathname === '/en' || pathname === '/es') return '/';
  return pathname;
};

export const languageFromPath = (pathname: string): Language => {
  if (pathname.startsWith('/en')) return 'en';
  if (pathname.startsWith('/es')) return 'es';
  return 'fr';
};

export const canonicalUrl = (pathname: string): string => {
  return pathname === '/' ? SITE_ORIGIN : `${SITE_ORIGIN}${pathname}`;
};

export const alternateUrls = (pathname: string): Record<Language | 'x-default', string> => {
  const base = stripLocalePrefix(pathname);
  const suffix = base === '/' ? '' : base;

  return {
    fr: `${SITE_ORIGIN}${suffix}`,
    en: `${SITE_ORIGIN}/en${suffix}`,
    es: `${SITE_ORIGIN}/es${suffix}`,
    'x-default': `${SITE_ORIGIN}${suffix}`,
  };
};

export const ogLocale = (language: Language): string => {
  if (language === 'en') return 'en_US';
  if (language === 'es') return 'es_ES';
  return 'fr_FR';
};

export const ogLocaleAlternates = (language: Language): string[] => {
  const all = ['fr_FR', 'en_US', 'es_ES'];
  const current = ogLocale(language);
  return all.filter((locale) => locale !== current);
};
